module.exports = __webpack_public_path__ + "static/img/HPW LOGO 3.fc2e683.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HPW LOGO 3.png
// module id = rIV5
// module chunks = 1